import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { FadeUp } from "./Reveal";

export const ServiceCard = ({ service, icon: Icon, index = 0, showImage = true }) => {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - r.left}px`);
    el.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  return (
    <FadeUp delay={index * 0.08}>
      <div
        ref={ref}
        onMouseMove={onMove}
        data-testid={`service-card-${service.id}`}
        className="clip-corner group relative h-full overflow-hidden border border-zinc-800 bg-carbon transition-colors duration-500 hover:border-volt/50"
      >
        <div
          className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
          style={{ background: "radial-gradient(280px at var(--mx, 50%) var(--my, 50%), rgba(163,230,53,0.14), transparent 70%)" }}
        />
        {showImage && service.image && (
          <div className="relative h-44 sm:h-52 overflow-hidden border-b border-zinc-800">
            <img
              src={service.image}
              alt={service.title}
              loading="lazy"
              className="h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-carbon via-transparent to-transparent" />
          </div>
        )}
        <div className="relative p-6 sm:p-8">
          <div className="mb-4 flex h-11 w-11 items-center justify-center clip-badge bg-volt/10 border border-volt/30 text-volt">
            <Icon size={20} strokeWidth={2.2} />
          </div>
          <h3 className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight text-white mb-3">
            {service.title}
          </h3>
          <p className="text-sm sm:text-base leading-relaxed text-zinc-400 mb-5">{service.desc}</p>
          <Link
            to="/contact"
            data-testid={`service-card-${service.id}-cta`}
            className="inline-flex items-center gap-1.5 font-mono text-xs font-bold uppercase tracking-[0.2em] text-volt hover:text-volt-soft transition-colors"
          >
            Get a quote <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
    </FadeUp>
  );
};
